<template>
  <VehicleFilter
    :manufacturers="manufacturers"
    :colors="colors"
    :gears="gears"
    :vehicle-groups="vehicleGroups"
    :fuel-types="fuelTypes"
    :models="models"
    :durations="durations"
    :subscription-equipments="subscriptionEquipments"
    :selected-manufacturers="selectedManufacturers"
    :selected-colors="selectedColors"
    :selected-fuel-types="selectedFuelTypes"
    :selected-gears="selectedGears"
    :selected-vehicle-groups="selectedVehicleGroups"
    :selected-models="selectedModels"
    :selected-subscription-equipments="selectedSubscriptionEquipments"
    :selected-durations="selectedDurations"
    @filter-changed="handleFilterChange"
  />
  <div class="orm-col-xs-12 orm-col-md-8 orm-col-lg-9 first-xs last-md">
    <div v-if="carGroup.length > 0 && !isLoading && !error.carGroup">
      <div class="orm-row center-xs start-md orm-h100">
        <Car
          v-for="car in carGroup"
          :key="car.id"
          :data="car"
          :filter="showCar(car)"
          :availability-plan="availabilityPlan"
          :abo="true"
          :aboV2="true"
          @openContact="openContact"
        />
      </div>
      <div class="orm-row center-xs orm-mb-32">
        <button
          class="orm-btn--outline"
          @click="loadNextPage"
          v-if="hasNextPage"
        >
          {{ i18n("step1/loadmore") || "Zeig mir Weitere" }}
        </button>
      </div>
    </div>
    <div
      class="text-center orm-mt-64 orm-mb-94"
      v-else-if="carGroup.length == 0 && !isLoading && !error.carGroup"
      v-html="i18n('step1/nocars')"
    ></div>
    <div
      class="text-center orm-mt-64 orm-mb-94"
      v-else-if="carGroup.length == 0 && !isLoading && error.carGroup"
    >
      <div
        class="text-center orm-mt-64 orm-mb-16"
        v-html="i18n('error/autoaboNotAvailableForCustomer')"
      ></div>
      <button class="orm-button__cta outline small" @click="openContact(car)">
        {{ i18n("cargroup/error/button") }}
      </button>
    </div>
    <div class="orm-preload-page orm-preload-page-static orm-mt-64" v-else>
      <div class="orm-loader-spinner">
        <i class="fa fa-spinner-third orm-rotate360"></i>
      </div>
    </div>
    <div
      class="orm-col-xs-12 orm-background--white orm-py-30 orm-px-30"
      v-if="i18n('step1/description') && !isLoading && showSaleTax"
      v-html="i18n('step1/description')"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Car from "@/components/cargroup/car.vue";
import store from "@/store";
import i18n from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import VehicleFilter from "@/components/ui/VehicleFilter.vue";

export default defineComponent({
  name: "VehicleGrid",
  props: { data: Object, type: String },
  mixins: [i18n],
  data() {
    return {
      vehicles: [],
      carID: String,
      selectedCargroupInfo: {},
      stationSelected: String,
      carGroup: [],
      groupFilter: [],
      manufacturers: [],
      colors: [],
      gears: [],
      availabilities: [],
      vehicleTypes: [],
      vehicleGroups: [],
      fuelTypes: [],
      models: [],
      durations: [],
      subscriptionEquipments: [],
      selectwait: true,
      selectedAll: true,
      selectedGroup: {},
      selectedManufacturers: {},
      selectedColors: {},
      selectedFuelTypes: {},
      selectedGears: {},
      selectedVehicleTypes: {},
      selectedAvailabilities: {},
      selectedModels: {},
      selectedSubscriptionEquipments: {},
      selectedDurations: {},
      selectedVehicleGroups: {},
      contactCarGroup: {},
      isLoading: true,
      error: {
        carGroup: false,
        show: false,
        data: {
          header: this.i18n("error/default/header"),
          content: this.i18n("error/default/content"),
          buttonFirst: "Home",
          buttonFirstLabel: this.i18n("error/default/buttonFirstLabel"),
        },
      },
      showContact: false,
      showSaleTax: false,
      selectedAbo: store.getters["reservation/GET_SELECTEDABO"],
      abolength: [],
      waitforreset: false,
      startwatch: null,
      stopwatch: null,
      hasNextPage: false,
      page: 1,
    };
  },
  components: {
    VehicleFilter,
    Car,
  },
  async mounted() {
    const showTax = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_HIDE_TAX_TEXT"
    );

    switch (showTax) {
      case "1":
        this.showSaleTax = true;
        break;
      default:
        break;
    }
  },
  setup() {
    const stations = store.state.stations;

    // console.log("abolength", abolength);
    return {
      stations,
      store,
    };
  },
  async created() {
    // this.waitforreset = true;
    await store.dispatch("userSession/RESET_VEHICLE").then();

    this.selectedAbo = await store.getters["reservation/GET_SELECTEDABO"];
    this.abolength = await store.getters["reservation/GET_ABO_LENGTH"];
    // await store.dispatch("stations/SET_OPENINGTIMES").then(() => {
    //   this.waitforreset = false;
    // });

    if (!this.abolength.find((x) => x.key == this.selectedAbo[0])) {
      this.waitforreset = true;
      await store.dispatch("reservation/RESET_ABOLENGTH").then(() => {
        this.waitforreset = false;
      });
    }

    store.dispatch("reservation/DELETE_TARIF");
    store.dispatch("payment/DELETE_CONCARDIS");
    store.dispatch("reservation/DELETE_SUCCESS_RESERVATION");
    this.stationSelected = await store.getters["userSession/GET_STATION"];

    const fallbackStation = this.returnFallbackStation(this.stationSelected);
    if (this.stationSelected != fallbackStation.id) {
      store.dispatch("userSession/SET_STATION", fallbackStation.id);
      this.stationSelected = fallbackStation.id;
    }

    if (this.stationSelected == null) {
      if (process.env.VUE_APP_STANDALONE == "true") {
        this.$router.push({ name: "Home" });
      } else {
        window.location.href = process.env.VUE_APP_BASE_URL;
      }
      return;
    }
    const carID = await store.getters["userSession/GET_CARGROUP_ABO"];
    this.carID = carID;

    /*if (carID == null) {
      this.error.show = true;
      return false;
    }*/

    const filters = await store.dispatch("cargroup/GET_AUTO_ABO_FILTER");

    //console.log("filters", filters);

    this.manufacturers = filters.manufacturers;
    this.colors = filters.colors;
    this.models = filters.models;
    this.durations = filters.durations;
    this.fuelTypes = filters.fuelTypes;
    this.vehicleGroups = filters.vehicleTypes;
    this.gears = filters.gears;
    this.availabilities = filters.availabilities;
    this.subscriptionEquipments = filters.equipments;

    await this.loadCarGroup();
    // store.watch(
    //   (state, getters) => getters["userSession/GET_RESERVATIONTIME_START"],
    //   () => {
    //     this.loadCarGroup();
    //   }
    // );
    // store.watch(
    //   (state, getters) => getters["userSession/GET_RESERVATIONTIME_END"],
    //   () => {
    //     this.loadCarGroup();
    //   }
    // );
  },
  methods: {
    async selectAbo(abo) {
      if (!this.isLoading) {
        await store.dispatch("reservation/SET_ABOLENGTH", abo);
        await store.dispatch("stations/SET_OPENINGTIMES");
        // this.isLoading = true;
        this.selectedAbo = abo;
        // this.loadCarGroup();
      }
    },
    async loadNextPage() {
      this.page++;

      const vehicles = await store.dispatch("cargroup/GET_VEHICLES_V2", {
        vehicle_group_id: Object.keys(
          store.getters["userSession/GET_ABO_VEHICLEGROUP"]
        )
          .filter((val) => {
            return store.getters["userSession/GET_ABO_VEHICLEGROUP"][val];
          })
          .map((key) => [key]),
        manufacturer: Object.keys(this.selectedManufacturers).map((key) => [
          key,
        ]),
        models: Object.keys(this.selectedModels).map((key) => [key]),
        durations: Object.keys(this.selectedDurations).map((key) => [key]),
        fuel_types: Object.keys(this.selectedFuelTypes).map((key) => [key]),
        vehicle_types: Object.keys(this.selectedVehicleTypes).map((key) => [
          key,
        ]),
        colors: Object.keys(this.selectedColors).map((key) => [key]),
        availabilities: Object.keys(this.selectedAvailabilities).map((key) => [
          key,
        ]),
        gears: Object.keys(this.selectedGears).map((key) => [key]),
        equipments: Object.keys(
          this.selectedSubscriptionEquipments
        ).map((key) => [key]),
        page: this.page,
      });

      this.carGroup = [...this.carGroup, ...vehicles.vehicles];
      this.hasNextPage = vehicles.hasNextPage;
    },
    async loadCarGroup() {
      this.isLoading = true;
      this.stationSelected = await store.getters["userSession/GET_STATION"];
      this.carGroup = [];

      const vehicles = await store.dispatch("cargroup/GET_VEHICLES_V2", {
        vehicle_group_id: Object.keys(
          store.getters["userSession/GET_ABO_VEHICLEGROUP"]
        )
          .filter((val) => {
            return store.getters["userSession/GET_ABO_VEHICLEGROUP"][val];
          })
          .map((key) => [key]),
        manufacturer: Object.keys(this.selectedManufacturers).map((key) => [
          key,
        ]),
        models: Object.keys(this.selectedModels).map((key) => [key]),
        durations: Object.keys(this.selectedDurations).map((key) => [key]),
        fuel_types: Object.keys(this.selectedFuelTypes).map((key) => [key]),
        colors: Object.keys(this.selectedColors).map((key) => [key]),
        availabilities: Object.keys(this.selectedAvailabilities).map((key) => [
          key,
        ]),
        gears: Object.keys(this.selectedGears).map((key) => [key]),
        equipments: Object.keys(
          this.selectedSubscriptionEquipments
        ).map((key) => [key]),
      });

      this.hasNextPage = vehicles.hasNextPage;

      this.carGroup = vehicles.vehicles;

      this.models = vehicles.models;
      this.vehicleGroups = vehicles.vehicleTypes;
      this.manufacturers = vehicles.manufacturers;
      this.fuelTypes = vehicles.fuelTypes;
      this.colors = vehicles.colors;
      this.availabilities = vehicles.availabilities;
      this.gears = vehicles.gears;
      this.durations = vehicles.durations;
      this.subscriptionEquipments = vehicles.equipments;

      if (vehicles) {
        if (vehicles.error) {
          this.carGroup = [];
          this.error.carGroup = true;
          this.isLoading = false;
          return;
        }
      }

      this.isLoading = false;
      // await store
      //   .dispatch("cargroup/GET_CARGROUP_FROM_STATION", this.stationSelected)
      //   .then((res) => {
      //     const object = res;
      //     for (const key in object) {
      //       if (Object.prototype.hasOwnProperty.call(object, key)) {
      //         const element = object[key];
      //         object.find((x) => x.id === element.id).price = [];
      //       }
      //     }
      //     this.carGroup = object;
      //     this.isLoading = false;
      //   });

      this.groupFilter = await store.getters["cargroup/GET_GROUPFILTER"];
    },
    showCar(group) {
      return true;
    },
    handleFilterChange(filterData) {
      const { type, selectedItems } = filterData;

      switch (type) {
        case "manufacturer":
          this.selectedManufacturers = selectedItems;
          break;
        case "color":
          this.selectedColors = selectedItems;
          break;
        case "fueltype":
          this.selectedFuelTypes = selectedItems;
          break;
        case "gear":
          this.selectedGears = selectedItems;
          break;
        case "vehicleType":
          this.selectedVehicleTypes = selectedItems;
          break;
        case "vehicleGroup":
          this.selectedVehicleGroups = selectedItems;
          break;
        case "model":
          this.selectedModels = selectedItems;
          break;
        case "duration":
          this.selectedDurations = selectedItems;
          break;
        case "subscriptionEquipment":
          this.selectedSubscriptionEquipments = selectedItems;
          break;
      }
      this.loadCarGroup();
    },
    showError(ev) {
      console.log(ev);
      this.error.show = true;
      //this.error.data.content = ev.form.message;
    },
    openContact(car) {
      this.contactCarGroup = car;
      this.showContact = true;
    },
    returnFallbackStation(currentStation) {
      const stationType = "ABO";
      const possibleStations =
        store.getters["stations/GET_STATIONS_FILTERED"][stationType];

      for (const station of possibleStations) {
        if (station.id === currentStation) {
          return station;
        }
      }
      return possibleStations[0];
    },
  },
});
</script>
